module.exports = __webpack_public_path__ + "img/暄妍.f76585a.png";